<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
import { createWidgetMixin } from 'vue-instantsearch'
import { connectConfigure } from 'instantsearch.js/es/connectors'

export default {
  name: 'CustomConfigure',
  mixins: [createWidgetMixin({ connector: connectConfigure })],
  props: {
    parameters: {
      type: Object,
      default: () => {}
    },
    hitsPerPage: {
      type: Number,
      default: 20
    }
  },
  computed: {
    widgetParams () {
      return {
        searchParameters: this.parameters || {},
        hitsPerPage: this.hitsPerPage
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
